import { set } from "js-cookie";

/**
 * Grant Recpients.
 */
export default function grantRecipientsSection() {
  const grantRecipients = document.getElementById('grantRecipients');
  if (!grantRecipients) return;

  // Filters
  const grantRecipientsYearFilters = document.getElementById('grantRecipientsYearFilters');
  const yearButtons = grantRecipientsYearFilters.querySelectorAll('button');
  let selectedYear = yearButtons[yearButtons.length-1].innerHTML;
  const updateYearFilter = year => {
    selectedYear = year;

    // Highlight/selected
    yearButtons.forEach(button => {
      if (button.innerHTML === selectedYear) button.classList.add('selected');
      else button.classList.remove('selected');
    });

    // Apply year filter to swiper
    const recipientSlides = grantRecipients.querySelectorAll('.recipients');
    recipientSlides.forEach(slide => {
      if (slide.dataset.year === selectedYear) {
        slide.classList.add('flex');
        slide.classList.remove('hidden');
      } else {
        slide.classList.remove('flex');
        slide.classList.add('hidden');
      }
    });
  }

  // Year filter buttons
  yearButtons.forEach(button => {
    button.addEventListener('click', event => {
      updateYearFilter(button.innerHTML);
    });
  });

  // Init
  updateYearFilter(selectedYear);
}



// WEBPACK FOOTER //
// ./source/scripts/sections/grant-recipients.js